const styles = {
  container: {
    padding: '0 50px',
    marginTop: 64,
    height: '90vh',
    backgroundColor: 'white',
  }
}

export default styles;



// WEBPACK FOOTER //
// ./src/containers/styles/MainContainer.js